var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar",class:{ dark: !!_vm.darkMode }},[_c('mobile-nav',{staticClass:"md:hidden"}),_c('desktop-nav',{staticClass:"hidden md:flex"}),_c('change-locale')],1)}
var staticRenderFns = []

export { render, staticRenderFns }